import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { GlobalHelper } from '../Common/global.service';

@Injectable({
  providedIn: 'root'
})
export class HrService {

  constructor(private globalHelper:GlobalHelper, private httpclient: HttpClient) { }

  // Shift

  SaveShift(data: any): Observable<any> {
    let param = 'objShift=' + data;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'HR/SaveShift?' + encodeURI(param), { headers: reqHeader });
  }
  ShiftMarkActive(ShiftID, IsActive): Observable<any> {
    let param = 'ShiftID=' + ShiftID + '&IsActive=' + IsActive;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'HR/ShiftMarkActive?' + encodeURI(param), { headers: reqHeader });
  }


  GetAllShift(): Observable<any> {
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'HR/GetAllShift?', { headers: reqHeader });
  }


 GetStaffShiftMap(ShiftID: any): Observable<any> {
    let param = 'ShiftID=' + ShiftID;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'HR/GetStaffShiftMap?' + encodeURI(param), { headers: reqHeader });
  }

  SaveSalaryMonth(data: any): Observable<any> {
    let param = 'objSalaryMonth=' + data;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'HR/SaveSalaryMonth?' + encodeURI(param), { headers: reqHeader });
  }
  SalaryMonthMarkActive(ShiftID, IsActive): Observable<any> {
    let param = 'MonthID=' + ShiftID + '&IsActive=' + IsActive;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'HR/SalaryMonthMarkActive?' + encodeURI(param), { headers: reqHeader });
  }


  GetSalaryMonth(): Observable<any> {
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'HR/GetSalaryMonth?', { headers: reqHeader });
  }

  GetEmployeeList(strdata: any): Observable<any> {
    let param = 'strEmployee=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'HR/GetEmployeeList?' + encodeURI(param), { headers: reqHeader });
  }

  GetEmployeeAllowancesList(strdata: any): Observable<any> {
    let param = 'strEmployee=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'HR/GetEmployeeAllowancesList?' + encodeURI(param), { headers: reqHeader });
  }

  SavePaymentMode(StaffList: any): Observable<any> {
    let formData = new FormData();
    formData.append("StaffList", StaffList);

    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'HR/SavePaymentMode', formData);
  }

  GetAllEmployeeForPaymentMode(strdata: any): Observable<any> {
    let param = 'ObjEmp=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'HR/GetAllEmployeeForPaymentMode?' + encodeURI(param), { headers: reqHeader });
  }

  SaveStaffAllowances(strEmployee, EmpList): Observable<any> {
    let formData = new FormData();
    formData.append("strEmployee", strEmployee);
    formData.append("EmpList", EmpList);
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'HR/SaveStaffAllowances', formData);
  }


  GetLoanList(strdata: any): Observable<any> {
    let param = 'StaffID=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Payroll/GetLoanList?' + encodeURI(param), { headers: reqHeader });
  }

  SearchEmployeeLoanList(strdata: any): Observable<any> {
    let param = 'LoanID=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'EmployeeLoan/SearchEmployeeLoanList?' + encodeURI(param), { headers: reqHeader });
  }

  GetAllLoan(data): Observable<any> {
    let formData = new FormData();
    formData.append("Staffdetails", data);
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'HR/GetAllLoan', formData);
  }

  SaveLoan(prm): Observable<any> {
    let formData = new FormData();
    formData.append("Details", prm);
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'HR/SaveLoan', formData);
  }

  CancelLoan(LoanID): Observable<any> {
    let formData = new FormData();
    formData.append("LoanID", LoanID);
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'HR/CancelLoan', formData);
  }


  ViewLoan(LoanID): Observable<any> {
    let formData = new FormData();
    formData.append("LoanID", LoanID);
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'HR/ViewLoan', formData);
  }


  SaveLoanCancelled(data, prm): Observable<any> {
    let formData = new FormData();
    formData.append("StaffID", data);
    formData.append("Details", prm);

    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'HR/SaveLoanCancelled', formData);
  }


  SaveGenrate(strdata: any): Observable<any> {
    let param = 'objSal=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'HR/SaveGenrate?' + encodeURI(param), { headers: reqHeader });
  }


  SaveGenrateFinal(objSal, List): Observable<any> {
    let formData = new FormData();
    formData.append("objSal", objSal);
    formData.append("List", List);

    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'HR/SaveGenrateFinal', formData);
  }

 
  GetAllEmployeeList(strdata: any): Observable<any> {
    let param = 'ObjEmp=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'HR/GetAllEmployeeList?' + encodeURI(param), { headers: reqHeader });
  }


  SaveSalaryMapping(data: any): Observable<any> {
    let formData = new FormData();
    formData.append("ObjEmployee", data);


    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'HR/SaveSalaryMapping', formData);
  }

  GetSalaryComponentListByID(StaffID: any): Observable<any> {
    let param = 'StaffID=' + StaffID;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'HR/GetSalaryComponentListByID?' + encodeURI(param), { headers: reqHeader });
  }


  
  GetStaffSalaryReport(data: any): Observable<any> {
    let param = 'strStaffSalary=' + data;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'HR/GetStaffSalaryReport?' + encodeURI(param), { headers: reqHeader });
  }


  GetStaffSalary(data: any): Observable<any> {
    let param = 'strStaffSalary=' + data;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'HR/GetStaffSalary?' + encodeURI(param), { headers: reqHeader });
  }
  GetStaffSalaryPrint(data: any): Observable<any> {
    let param = 'strStaffSalary=' + data;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'HR/GetStaffSalaryPrint?' + encodeURI(param), { headers: reqHeader });
  }

  GetStaffSalaryStatus(data: any): Observable<any> {
    let param = 'strStaffSalary=' + data;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'HR/GetStaffSalaryStatus?' + encodeURI(param), { headers: reqHeader });
  }

  UpdateStaffSalaryPayment(BankAccountID, strStaffSalary): Observable<any> {
    let formData = new FormData();
    formData.append("strStaffSalary", strStaffSalary);
    formData.append("BankAccountID", BankAccountID);

    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'HR/UpdateStaffSalaryPayment', formData);
  }


  SavePayCash(MonthID, salarylsit): Observable<any> {
    let formData = new FormData();
    formData.append("MonthID", MonthID);
    formData.append("lstSalaryList", salarylsit);
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'HR/PayByCash', formData);
  }

  GetSalaryStatement(data: any): Observable<any> {
    let param = 'strStaffSalary=' + data;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'HR/GetSalaryStatement?' + encodeURI(param), { headers: reqHeader });
  }

  GetSalarySlip(data: any): Observable<any> {
    let param = 'SalaryID=' + data;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'HR/GetSalarySlip?' + encodeURI(param), { headers: reqHeader });
  }

  SaveSalaryComponent(data: any): Observable<any> {
    let param = 'objSalary=' + data;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'HR/SaveSalaryComponent?' + encodeURI(param), { headers: reqHeader });
  }

  SalaryComponentMarkActive(strdata: any): Observable<any> {

    let Parameter = 'objSalary=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'HR/SalaryComponentMarkActive?' + encodeURI(Parameter),
      { headers: reqHeader });
  }

  GetSalaryComponent(): Observable<any> {

    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'HR/GetSalaryComponent', { headers: reqHeader });
  }

  

  GetStaffLeaveReport(data, str): Observable<any> {

    let param = 'objStaffLeaveReport=' + data + '&Print=' + str;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'HR/GetStaffLeaveReport?' + encodeURI(param), { headers: reqHeader });
  }

  GetStaffMonthlyAttendanceSummary(data: any): Observable<any> {
    let param = 'objStaffMonthlyAttendance=' + data;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'HR/GetStaffMonthlyAttendanceSummary?' + encodeURI(param), { headers: reqHeader });
  }

  SaveStaffMonthlyAttendance(data, prm): Observable<any> {

    let formData = new FormData();
    formData.append("ObjAttendance", data);
    formData.append("objAttendanceList", prm);

    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'HR/SaveStaffMonthlyAttendance', formData);
  }

  GetStaffDailyAttendance(data: any): Observable<any> {
    let param = 'objDailyAttendance=' + data;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'HR/GetStaffDailyAttendance?' + encodeURI(param), { headers: reqHeader });
  }

  DailyAttendanceDownload(data: any): Observable<any> {
    let param = 'objDailyAttendance=' + data;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'HR/DailyAttendanceDownload?' + encodeURI(param), { headers: reqHeader });
  }


  SaveStaffDailyAttendance(data, strAttendance): Observable<any> {
    let formData = new FormData();
    formData.append("ObjAttendance", data);
    formData.append("objList", strAttendance);

    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'HR/SaveStaffDailyAttendance', formData);
  }

  // Month Wise Attendance

  GetStaffMonthWiseAttendance(data): Observable<any> {
    let formData = new FormData();
    formData.append("ObjModel", data);

    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'HR/GetStaffMonthWiseAttendance', formData);
  }

  SaveStaffMonthWiseAttendance(strAttendance, data): Observable<any> {
    let formData = new FormData();
    formData.append("ObjModel", data);
    formData.append("objList", strAttendance);

    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'HR/SaveStaffMonthWiseAttendance', formData);
  }

  MonthlyAttendanceDownload(data: any): Observable<any> {
    let param = 'objDailyAttendance=' + data;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'HR/MonthlyAttendanceDownload?' + encodeURI(param), { headers: reqHeader });
  }
  // Monthly Attendance Report

  GetStaffMonthlyAttendance(data: any): Observable<any> {
    let param = 'objStaffMonthlyAttendance=' + data;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'HR/GetStaffMonthlyAttendance?' + encodeURI(param), { headers: reqHeader });
  }

  GetStaffMonthlyAttendanceDownload(data: any): Observable<any> {
    let param = 'objStaffMonthlyAttendance=' + data;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'HR/GetStaffMonthlyAttendanceDownload?' + encodeURI(param), { headers: reqHeader });
  }
  // Employee Over Time

  GetAllEmployeeOverTime(data): Observable<any> {
    let formData = new FormData();
    formData.append("ObjEmp", data);

    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'HR/GetAllEmployeeOverTime', formData);
  }

  SaveEmployeeOverTime(ObjModel, objList): Observable<any> {
    let formData = new FormData();
    formData.append("ObjModel", ObjModel);
    formData.append("objList", objList);

    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'HR/SaveEmployeeOverTime', formData);
  }
 
  GetAllStaffAttendance(AttendanceDate, ShiftID): Observable<any> {
    let formData = new FormData();
    formData.append("AttendanceDate", AttendanceDate);
    formData.append("ShiftID", ShiftID);

    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'StaffAttendance/GetAllStaffAttendance', formData);
  }


  SaveStaffAttendance(StaffList, AttendanceDate, ShiftID): Observable<any> {
    let formData = new FormData();
    formData.append("StaffList", StaffList);
    formData.append("AttendanceDate", AttendanceDate);
    formData.append("ShiftID", ShiftID);
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'StaffAttendance/SaveStaffAttendance', formData);
  }


  GetShiftStaffMap(EmployeeCategoryID, PrimaryDepartmentID): Observable<any> {
    let formData = new FormData();
    formData.append("EmployeeCategoryID", EmployeeCategoryID);
    formData.append("PrimaryDepartmentID", PrimaryDepartmentID);

    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'StaffAttendance/GetShiftStaffMap', formData);
  }

 
  GetAllEmployeeShift(strdata: any): Observable<any> {
    let param = 'ObjEmp=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'HR/GetAllEmployeeShift?' + encodeURI(param), { headers: reqHeader });
  }

  GetAllStaffShiftMap(strdata: any): Observable<any> {
    let param = 'ObjEmp=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'HR/GetAllStaffShiftMap?' + encodeURI(param), { headers: reqHeader });
  }


  SaveEmployeeShiftMapping(data, list): Observable<any> {
    let formData = new FormData();
    formData.append("ObjEmployee", data);
    formData.append("EmployeeList", list);
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'HR/SaveEmployeeShiftMapping', formData);
  }

  SaveEmployeeShift(data: any): Observable<any> {
    let formData = new FormData();
    formData.append("ObjEmployee", data);

    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'HR/SaveEmployeeShift', formData);
  }
}
